window.translations = window.translations || {};
window.translations.fr = {
  charset: 'utf-8',
  translations: {
    '': {
      '': {
        msgid: '',
        msgstr: [
          'Project-Id-Version: \nPOT-Creation-Date: Wed Jun 04 2025 17:49:07 GMT+0200 (Mitteleuropäische Sommerzeit)\nPO-Revision-Date: \nLast-Translator: \nLanguage-Team: \nLanguage: fr\nMIME-Version: 1.0\nContent-Type: text/plain; charset=UTF-8\nContent-Transfer-Encoding: 8bit\nPlural-Forms: nplurals=2; plural=(n > 1);\nX-Generator: Poedit 3.5\n',
        ],
      },
      Zurück: { msgid: 'Zurück', msgstr: ['Retour'] },
      Inhaltsübersicht: {
        msgid: 'Inhaltsübersicht',
        msgstr: ['Aperçu du contenu'],
      },
      'Menü aufgeklappt': {
        msgid: 'Menü aufgeklappt',
        msgstr: ['Menu ouvert'],
      },
      'Detailliertes Menü': {
        msgid: 'Detailliertes Menü',
        msgstr: ['Menu détaillé'],
      },
      Schließen: { msgid: 'Schließen', msgstr: ['Fermer'] },
      'Sprache wählen': {
        msgid: 'Sprache wählen',
        msgstr: ['Choisir une langue'],
      },
      'Alle Ministerien': {
        msgid: 'Alle Ministerien',
        msgstr: ['Tous les ministères'],
      },
      Hauptnavigation: {
        msgid: 'Hauptnavigation',
        msgstr: ['Navigation principale'],
      },
      'Weitere interne und externe Links und Funktionen': {
        msgid: 'Weitere interne und externe Links und Funktionen',
        msgstr: ['Liens et fonctions internes et externes supplémentaires'],
      },
      Profil: { msgid: 'Profil', msgstr: [''] },
      Abmelden: { msgid: 'Abmelden', msgstr: ['Se déconnecter'] },
      Anmelden: { msgid: 'Anmelden', msgstr: ['Registre'] },
      'Menü Schließen': { msgid: 'Menü Schließen', msgstr: ['Fermer le menu'] },
      Suche: { msgid: 'Suche', msgstr: ['Recherche'] },
      'Suche aufgeklappt': {
        msgid: 'Suche aufgeklappt',
        msgstr: ['Recherche ouverte'],
      },
      'Suchbegriff eingeben': {
        msgid: 'Suchbegriff eingeben',
        msgstr: ['Saisir le terme recherché'],
      },
      'Wonach suchen Sie?': {
        msgid: 'Wonach suchen Sie?',
        msgstr: ['Que cherchez-vous?'],
      },
      'Die Suche konnte nicht geladen werden. Bitte versuchen Sie es später erneut.':
        {
          msgid:
            'Die Suche konnte nicht geladen werden. Bitte versuchen Sie es später erneut.',
          msgstr: [
            'La carte n’a pas pu être chargée. Veuillez réessayer plus tard.',
          ],
        },
      Suchfunktion: {
        msgid: 'Suchfunktion',
        msgstr: ['Fonction de recherche'],
      },
      'Inhaltsübersicht mit Suchfunktion': {
        msgid: 'Inhaltsübersicht mit Suchfunktion',
        msgstr: ['Aperçu du contenu'],
      },
      Auswählen: { msgid: 'Auswählen', msgstr: ['Choisir'] },
      'Menü öffnen und schließen': {
        msgid: 'Menü öffnen und schließen',
        msgstr: ['Ouvrir et fermer le menu'],
      },
      'Nicht gefunden.': { msgid: 'Nicht gefunden.', msgstr: ['Pas trouvé.'] },
      Kommune: { msgid: 'Kommune', msgstr: ['Commune'] },
      'Kommune auswählen': {
        msgid: 'Kommune auswählen',
        msgstr: ['Choisir commune'],
      },
      'Berechneter Hebesatz für die Grundsteuer B': {
        msgid: 'Berechneter Hebesatz für die Grundsteuer B',
        msgstr: [''],
      },
      'Nutzen Sie die Filterfunktion': {
        msgid: 'Nutzen Sie die Filterfunktion',
        msgstr: [''],
      },
      'zur Anzeige der gewünschten Daten.': {
        msgid: 'zur Anzeige der gewünschten Daten.',
        msgstr: [''],
      },
      'Suche abschicken': {
        msgid: 'Suche abschicken',
        msgstr: ['Envoyer la recherche'],
      },
      'Top-Themen': { msgid: 'Top-Themen', msgstr: ['Souvent recherché'] },
      'Tragen Sie hier Ihre Einkommensteuer in Euro ein:': {
        msgid: 'Tragen Sie hier Ihre Einkommensteuer in Euro ein:',
        msgstr: [''],
      },
      'Einkommenssteuer in Euro': {
        msgid: 'Einkommenssteuer in Euro',
        msgstr: [''],
      },
      Berechnen: { msgid: 'Berechnen', msgstr: [''] },
      'Von diesem Betrag erhalten:': {
        msgid: 'Von diesem Betrag erhalten:',
        msgstr: [''],
      },
      'Klicken Sie auf die Elemente und erfahren Sie detailliert, was mit dem Landesanteil Ihrer Einkommensteuer geschieht.':
        {
          msgid:
            'Klicken Sie auf die Elemente und erfahren Sie detailliert, was mit dem Landesanteil Ihrer Einkommensteuer geschieht.',
          msgstr: [''],
        },
      'Betrag weiter aufschlüsseln': {
        msgid: 'Betrag weiter aufschlüsseln',
        msgstr: [''],
      },
      Entspricht: { msgid: 'Entspricht', msgstr: [''] },
      'der Gesamtsumme': { msgid: 'der Gesamtsumme', msgstr: [''] },
      'Aufschlüsselung des Betrags:': {
        msgid: 'Aufschlüsselung des Betrags:',
        msgstr: [''],
      },
      'Wert zu gering': { msgid: 'Wert zu gering', msgstr: [''] },
      'Eine Ebene höher gehen': {
        msgid: 'Eine Ebene höher gehen',
        msgstr: [''],
      },
      'Aufschlüsselung von Steuergeldern:': {
        msgid: 'Aufschlüsselung von Steuergeldern:',
        msgstr: [''],
      },
      'Als Liste darstellen': { msgid: 'Als Liste darstellen', msgstr: [''] },
      'Als Diagramm darstellen': {
        msgid: 'Als Diagramm darstellen',
        msgstr: [''],
      },
      'Der Wert ist so gering, dass er nicht dargestellt werden kann.': {
        msgid: 'Der Wert ist so gering, dass er nicht dargestellt werden kann.',
        msgstr: [''],
      },
      'Copyright Info öffnen': {
        msgid: 'Copyright Info öffnen',
        msgstr: ['Ouvrir les informations sur les droits d’auteur'],
      },
      'Copyright Info schließen': {
        msgid: 'Copyright Info schließen',
        msgstr: ['Fermer les informations de droits d’auteur'],
      },
      'Öffnet in neuem Fenster': {
        msgid: 'Öffnet in neuem Fenster',
        msgstr: ['S’ouvre dans un nouvel onglet'],
      },
      'Video abspielen': {
        msgid: 'Video abspielen',
        msgstr: ['Lire la vidéo'],
      },
      'Dropdown öffnen': {
        msgid: 'Dropdown öffnen',
        msgstr: ['Ouvrir la liste déroulante'],
      },
      'Bitte geben Sie die Adresse des Mastodon-Servers ein, auf dem Sie teilen möchten.':
        {
          msgid:
            'Bitte geben Sie die Adresse des Mastodon-Servers ein, auf dem Sie teilen möchten.',
          msgstr: [
            'Veuillez saisir l’adresse du serveur Mastodon sur lequel vous souhaitez partager.',
          ],
        },
      Teilen: { msgid: 'Teilen', msgstr: ['Partager'] },
      'Es ist ein Fehler aufgetreten.': {
        msgid: 'Es ist ein Fehler aufgetreten.',
        msgstr: ['Une erreur s’est produite.'],
      },
      'Maximalwert erreicht': { msgid: 'Maximalwert erreicht', msgstr: [''] },
      'Minimalwert erreicht': { msgid: 'Minimalwert erreicht', msgstr: [''] },
      'Ungültiger Wert.': { msgid: 'Ungültiger Wert.', msgstr: [''] },
      'Anzahl erhöhen': { msgid: 'Anzahl erhöhen', msgstr: [''] },
      'Anzahl verringern': { msgid: 'Anzahl verringern', msgstr: [''] },
      'Meldung schließen': { msgid: 'Meldung schließen', msgstr: ['Fermer'] },
      'Anzahl wird aktualisiert.': {
        msgid: 'Anzahl wird aktualisiert.',
        msgstr: [''],
      },
      'Alle Kommentare schließen': {
        msgid: 'Alle Kommentare schließen',
        msgstr: [''],
      },
      'Alle Kommentare öffnen': {
        msgid: 'Alle Kommentare öffnen',
        msgstr: [''],
      },
      'Kommentar melden': { msgid: 'Kommentar melden', msgstr: [''] },
      'Als anstößig melden': { msgid: 'Als anstößig melden', msgstr: [''] },
      Nein: { msgid: 'Nein', msgstr: [''] },
      'Kommentar kann nicht mehr gemeldet werden': {
        msgid: 'Kommentar kann nicht mehr gemeldet werden',
        msgstr: [''],
      },
      Ok: { msgid: 'Ok', msgstr: [''] },
      'Kommentar löschen': { msgid: 'Kommentar löschen', msgstr: [''] },
      Löschen: { msgid: 'Löschen', msgstr: [''] },
      Kontakt: { msgid: 'Kontakt', msgstr: [''] },
      'Achtung:': { msgid: 'Achtung:', msgstr: [''] },
      Fehler: { msgid: 'Fehler', msgstr: [''] },
      Deutsch: { msgid: 'Deutsch', msgstr: ['Allemand'] },
      English: { msgid: 'English', msgstr: ['Anglais'] },
      Französisch: { msgid: 'Französisch', msgstr: ['Français'] },
      Sprache: { msgid: 'Sprache', msgstr: ['Langue'] },
      'Inhalte werden geladen.': {
        msgid: 'Inhalte werden geladen.',
        msgstr: [''],
      },
      Mehr: { msgid: 'Mehr', msgstr: [''] },
      'Es konnten keine weiteren Beiträge gefunden werden.': {
        msgid: 'Es konnten keine weiteren Beiträge gefunden werden.',
        msgstr: [''],
      },
      'Mehr anzeigen': { msgid: 'Mehr anzeigen', msgstr: [''] },
      'Inhalte konnten nicht geladen werden.': {
        msgid: 'Inhalte konnten nicht geladen werden.',
        msgstr: [''],
      },
      Themenbereich: { msgid: 'Themenbereich', msgstr: [''] },
      'Schließen JSX': { msgid: 'Schließen JSX', msgstr: ['Fermer'] },
      'Verwenden Sie STRG + Scrollen zum Zoomen der Karte': {
        msgid: 'Verwenden Sie STRG + Scrollen zum Zoomen der Karte',
        msgstr: ['Utilisez CTRL + défilement pour zoomer sur la carte'],
      },
      'Verwenden Sie ⌘ + Scrollen zum Zoomen der Karte': {
        msgid: 'Verwenden Sie ⌘ + Scrollen zum Zoomen der Karte',
        msgstr: ['Utilisez ⌘ + défilement pour zoomer sur la carte'],
      },
      'Die Karte konnte nicht geladen werden. Bitte versuchen Sie es später erneut.':
        {
          msgid:
            'Die Karte konnte nicht geladen werden. Bitte versuchen Sie es später erneut.',
          msgstr: [
            'La carte n’a pas pu être chargée. Veuillez réessayer plus tard.',
          ],
        },
      'Teilen via:': { msgid: 'Teilen via:', msgstr: ['Partager via:'] },
      Weiter: { msgid: 'Weiter', msgstr: ['Continuer'] },
      Seitennummerierung: {
        msgid: 'Seitennummerierung',
        msgstr: ['Numérotation des pages'],
      },
      'Zur letzten Seite': {
        msgid: 'Zur letzten Seite',
        msgstr: ['A la dernière page'],
      },
      'Zur Seite': { msgid: 'Zur Seite', msgstr: ['Vers la page'] },
      'Mehr Informationen': {
        msgid: 'Mehr Informationen',
        msgstr: ['Plus d’informations'],
      },
      'Weniger Informationen': {
        msgid: 'Weniger Informationen',
        msgstr: ['Moins d’informations'],
      },
      'Es konnten keine Themenseiten mit diesem Suchbegriff gefunden werden.': {
        msgid:
          'Es konnten keine Themenseiten mit diesem Suchbegriff gefunden werden.',
        msgstr: [
          'Aucune page thématique n’a pu être trouvée avec ce terme de recherche.',
        ],
      },
      'Lesezeit unbekannt': {
        msgid: 'Lesezeit unbekannt',
        msgstr: ['Temps de lecture inconnu'],
      },
      Lesezeit: { msgid: 'Lesezeit', msgstr: ['Temps de lecture'] },
      Minuten: { msgid: 'Minuten', msgstr: ['Minutes'] },
      Minute: { msgid: 'Minute', msgstr: ['Minute'] },
      'Zu Kachel': { msgid: 'Zu Kachel', msgstr: ['Pour carreau'] },
      'Vorherige Inhalte einblenden': {
        msgid: 'Vorherige Inhalte einblenden',
        msgstr: ['Afficher le contenu précédent'],
      },
      'Nächste Inhalte einblenden': {
        msgid: 'Nächste Inhalte einblenden',
        msgstr: ['Afficher le contenu suivant'],
      },
      Treffer: { msgid: 'Treffer', msgstr: [''] },
      'Extern:': { msgid: 'Extern:', msgstr: ['Externe:'] },
      'Download:': { msgid: 'Download:', msgstr: ['Download:'] },
      'E-Mail:': { msgid: 'E-Mail:', msgstr: ['E-Mail:'] },
      'Telefon:': { msgid: 'Telefon:', msgstr: ['Téléphone:'] },
      'Fax:': { msgid: 'Fax:', msgstr: ['Fax:'] },
      Link: { msgid: 'Link', msgstr: ['Link'] },
      'Artikel ist im Warenkorb. Auswahl ändern?': {
        msgid: 'Artikel ist im Warenkorb. Auswahl ändern?',
        msgstr: [''],
      },
      'Bitte akzeptieren Sie die technisch notwendigen Cookies': {
        msgid: 'Bitte akzeptieren Sie die technisch notwendigen Cookies',
        msgstr: ['Veuillez accepter les cookies techniquement nécessaires'],
      },
    },
  },
};
